import { SampleSetStatus } from '../enums';

// Sample Sets
const CREATE_SAMPLE_SET = 'create:sample_set';
const CREATE_PLATFORM_SAMPLE_SET = 'create:platform_sample_set';
const READ_USER_SAMPLE_SETS = 'read:user_sample_sets';
const READ_ORGANIZATION_SAMPLE_SETS = 'read:organization_sample_sets';
const READ_PLATFORM_SAMPLE_SETS = 'read:platform_sample_sets';
const UPDATE_USER_SAMPLE_SET = 'update:user_sample_set';
const UPDATE_ORGANIZATION_SAMPLE_SET = 'update:organization_sample_set';
const UPDATE_PLATFORM_SAMPLE_SET = 'update:platform_sample_set';
const DELETE_USER_SAMPLE_SET = 'delete:user_sample_set';
const DELETE_ORGANIZATION_SAMPLE_SET = 'delete:organization_sample_set';
const DELETE_PLATFORM_SAMPLE_SET = 'delete:platform_sample_set';

// Samples
const CREATE_SAMPLE = 'create:sample';
const CREATE_ORGANIZATION_SAMPLE = 'create:organization_sample';
const CREATE_PLATFORM_SAMPLE = 'create:platform_sample';
const CREATE_SAMPLE_SET_METADATA = 'create:sample_set_metadata';
const READ_USER_SAMPLES = 'read:user_samples';
const READ_ORGANIZATION_SAMPLES = 'read:organization_samples';
const READ_PLATFORM_SAMPLES = 'read:platform_samples';
const UPDATE_USER_SAMPLE = 'update:user_sample';
const UPDATE_ORGANIZATION_SAMPLE = 'update:organization_sample';
const UPDATE_PLATFORM_SAMPLE = 'update:platform_sample';
const UPDATE_SAMPLE_STATUS = 'update:sample_status';
const DELETE_USER_SAMPLE = 'delete:user_sample';
const DELETE_ORGANIZATION_SAMPLE = 'delete:organization_sample';
const DELETE_PLATFORM_SAMPLE = 'delete:platform_sample';
const DELETE_USER_SAMPLE_METADATA = 'delete:user_sample_metadata';
const DELETE_ORGANIZATION_SAMPLE_METADATA =
  'delete:organization_sample_metadata';
const DELETE_PLATFORM_SAMPLE_METADATA = 'delete:platform_sample_metadata';
const CREATE_PRIVILEGED_SAMPLE_METADATA = 'create:privileged_sample_metadata';
const READ_PRIVILEGED_SAMPLE_METADATA = 'read:privileged_sample_metadata';
const UPDATE_PRIVILEGED_SAMPLE_METADATA = 'update:privileged_sample_metadata';
const VIEW_RESULTS_METADATA = 'view:results_metadata';

// Organizations
const CREATE_ORGANIZATION = 'create:organization';
const READ_ORGANIZATION = 'read:organization';
const UPDATE_ORGANIZATION = 'update:organization';

// Users
const CREATE_ORGANIZATION_USER = 'create:organization_user';
const CREATE_PLATFORM_USER = 'create:platform_user';
const READ_USER = 'read:user';
const READ_ORGANIZATION_USERS = 'read:organization_users';
const READ_PLATFORM_USERS = 'read:platform_users';
const UPDATE_USER = 'update:user';
const UPDATE_ORGANIZATION_USERS = 'update:organization_users';
const UPDATE_PLATFORM_USERS = 'update:platform_users';

// Jobs
const CREATE_USER_JOB = 'create:user_job';
const CREATE_ORGANIZATION_JOB = 'create:organization_job';
const CREATE_PLATFORM_JOB = 'create:platform_job';
const CREATE_JOB_CONFIG = 'create:job_config'; // Grant access to custom job config page
const CREATE_CUSTOM_JOB = 'create:custom_job'; // Allows submission of non-standard jobs
const READ_USER_JOBS = 'read:user_jobs';
const READ_ORGANIZATION_JOBS = 'read:organization_jobs';
const READ_PLATFORM_JOBS = 'read:platform_jobs';
const UPDATE_JOB_STATUS = 'update:job_status';

// QC Features
const CREATE_QC_FEATURE = 'create:qc_feature';
const CREATE_QC_CHECK = 'create:qc_check';
const READ_QC_FEATURE = 'read:qc_feature';
const READ_QC_CHECK = 'read:qc_check';

// Training Labels
const CREATE_TRAINING_LABEL = 'create:training_label';
const READ_TRAINING_LABEL = 'read:training_label';
const UPDATE_TRAINING_LABEL = 'update:training_label';

// Inference Results
const CREATE_INFERENCE_RESULT = 'create:inference_result';
const READ_INFERENCE_RESULT = 'read:inference_result';
const READ_USER_INFERENCE_RESULT = 'read:user_inference_result';
const READ_ORGANIZATION_INFERENCE_RESULT = 'read:organization_inference_result';
const READ_PLATFORM_INFERENCE_RESULT = 'read:platform_inference_result';
const READ_PROPRIETARY_REPORT_INFO = 'read:proprietary_report_info';
const UPDATE_PLATFORM_INFERENCE_RESULT_LABEL =
  'update:platform_inference_result_label';
const READ_EMBEDDINGS_UMAP = 'read:embeddings_umap';
const READ_SAMPLE_EMBEDDINGS = 'read:sample_embeddings';

// Interpretive Reports
const READ_USER_INTERPRETIVE_REPORTS = 'read:user_interpretive_reports';
const READ_ORGANIZATION_INTERPRETIVE_REPORTS =
  'read:organization_interpretive_reports';
const READ_PLATFORM_INTERPRETIVE_REPORTS = 'read:platform_interpretive_reports';
const PUBLISH_USER_INTERPRETIVE_REPORTS = 'publish:user_interpretive_reports';
const PUBLISH_ORGANIZATION_INTERPRETIVE_REPORTS =
  'publish:organization_interpretive_reports';
const PUBLISH_PLATFORM_INTERPRETIVE_REPORTS =
  'publish:platform_interpretive_reports';

// Agents
const READ_USER_AGENT_ANALYSIS = 'read:user_agent_analysis';
const READ_USER_AGENT_CHAT = 'read:user_agent_chat';

// Acquisitions
const CREATE_ACQUISITION = 'create:acquisition';
const READ_ACQUISITION = 'read:acquisition';
const READ_USER_ACQUISITION = 'read:user_acquisition';
const READ_ORGANIZATION_ACQUISITION = 'read:organization_acquisition';
const READ_PLATFORM_ACQUISITION = 'read:platform_acquisition';
const CREATE_ACQUISITION_FEATURIZATION = 'create:acquisition_featurization';
const READ_ACQUISITION_FEATURIZATION = 'read:acquisition_featurization';
const UPDATE_ACQUISITION_FEATURIZATION = 'update:acquisition_featurization';

// Analytes
const CREATE_ANALYTE = 'create:analyte';
const CREATE_ANALYTE_USE = 'create:analyte_use';
const READ_ANALYTE = 'read:analyte';
const READ_BASE_ANALYTE = 'read:base_analyte';
const PROMOTE_ANALYTE = 'promote:analyte';
const UPDATE_ANALYTE = 'update:analyte';
const UPDATE_ANALYTE_METHOD = 'update:analyte_method';

// Adducts
const CREATE_ADDUCT = 'create:adduct';
const READ_ADDUCT = 'read:adduct';

// Methods
const CREATE_METHOD = 'create:method';
const READ_METHOD = 'read:method';
const UPDATE_METHOD = 'update:method';

// Products
const CREATE_PRODUCT = 'create:product';
const READ_ORGANIZATION_PRODUCT = 'read:organization_product';
const READ_PLATFORM_PRODUCT = 'read:platform_product';
const UPDATE_PRODUCT = 'update:product';
const READ_PRODUCT_VIEWER = 'read:product_viewer';
const UPDATE_PRODUCT_VIEWER = 'update:product_viewer';

// Configs
const CREATE_CONFIG = 'create:config';
const READ_CONFIG = 'read:config';
const UPDATE_CONFIG = 'update:config';

// Models
const CREATE_MODEL = 'create:model';
const READ_MODEL = 'read:model';
const UPDATE_MODEL = 'update:model';

// Candles
const READ_CANDLES = 'read:candles';

// Analyte Embeddings
const READ_ANALYTE_EMBEDDING = 'read:analyte_embedding';
const CREATE_ANALYTE_EMBEDDING = 'create:analyte_embedding';

// Viewers
const VIEW_EXPERIMENTS_PAGE = 'view:experiments_page';
const VIEW_EXPERIMENTS_V2_PAGE = 'view:experiments_v2_page';
const VIEW_ADMIN_PAGE = 'view:admin_page';
const VIEW_INFERENCE_RESULTS_PAGE = 'view:inference_results_page';
const VIEW_ORGANIZATIONS_PAGE = 'view:organizations_page';
const VIEW_ORGANIZATION_SETUP_PAGE = 'view:organization_setup_page';
const VIEW_DOWNLOAD_SOURCE_FILE = 'view:download_source_file';
const VIEW_METADATA_PAGE = 'view:metadata_page';
const VIEW_PROGRAMS_PAGE = 'view:programs_page';
const VIEW_JOB_RESULTS_PAGE = 'view:job_results_page';
const VIEW_ANALYTES_PAGE = 'view:analytes_page';
const VIEW_PRODUCTS_PAGE = 'view:products_page';
const VIEW_PEAK_AREA_PLOT = 'view:peak_area_plot';
const VIEW_XIC_PLOT = 'view:xic_plot';

const PERMISSIONS_STRINGS = {
  CREATE_SAMPLE_SET,
  CREATE_PLATFORM_SAMPLE_SET,
  READ_USER_SAMPLE_SETS,
  READ_ORGANIZATION_SAMPLE_SETS,
  READ_PLATFORM_SAMPLE_SETS,
  UPDATE_USER_SAMPLE_SET,
  UPDATE_ORGANIZATION_SAMPLE_SET,
  UPDATE_PLATFORM_SAMPLE_SET,
  DELETE_USER_SAMPLE_SET,
  DELETE_ORGANIZATION_SAMPLE_SET,
  DELETE_PLATFORM_SAMPLE_SET,
  CREATE_SAMPLE,
  CREATE_ORGANIZATION_SAMPLE,
  CREATE_PLATFORM_SAMPLE,
  CREATE_SAMPLE_SET_METADATA,
  READ_USER_SAMPLES,
  UPDATE_PLATFORM_INFERENCE_RESULT_LABEL,
  READ_ORGANIZATION_SAMPLES,
  READ_PLATFORM_SAMPLES,
  UPDATE_USER_SAMPLE,
  UPDATE_ORGANIZATION_SAMPLE,
  UPDATE_PLATFORM_SAMPLE,
  UPDATE_SAMPLE_STATUS,
  DELETE_USER_SAMPLE,
  DELETE_ORGANIZATION_SAMPLE,
  DELETE_PLATFORM_SAMPLE,
  CREATE_ORGANIZATION,
  READ_ORGANIZATION,
  UPDATE_ORGANIZATION,
  READ_PRODUCT_VIEWER,
  UPDATE_PRODUCT_VIEWER,
  CREATE_ORGANIZATION_USER,
  CREATE_PLATFORM_USER,
  READ_USER,
  READ_ORGANIZATION_USERS,
  READ_PLATFORM_USERS,
  UPDATE_USER,
  UPDATE_ORGANIZATION_USERS,
  UPDATE_PLATFORM_USERS,
  CREATE_USER_JOB,
  CREATE_ORGANIZATION_JOB,
  CREATE_PLATFORM_JOB,
  CREATE_JOB_CONFIG,
  CREATE_CUSTOM_JOB,
  READ_USER_JOBS,
  READ_ORGANIZATION_JOBS,
  READ_PLATFORM_JOBS,
  UPDATE_JOB_STATUS,
  CREATE_QC_FEATURE,
  CREATE_QC_CHECK,
  READ_QC_FEATURE,
  READ_QC_CHECK,
  CREATE_TRAINING_LABEL,
  READ_TRAINING_LABEL,
  UPDATE_TRAINING_LABEL,
  CREATE_INFERENCE_RESULT,
  READ_INFERENCE_RESULT,
  READ_USER_INFERENCE_RESULT,
  READ_ORGANIZATION_INFERENCE_RESULT,
  READ_PLATFORM_INFERENCE_RESULT,
  READ_PROPRIETARY_REPORT_INFO,
  READ_USER_INTERPRETIVE_REPORTS,
  READ_ORGANIZATION_INTERPRETIVE_REPORTS,
  READ_PLATFORM_INTERPRETIVE_REPORTS,
  PUBLISH_USER_INTERPRETIVE_REPORTS,
  PUBLISH_ORGANIZATION_INTERPRETIVE_REPORTS,
  PUBLISH_PLATFORM_INTERPRETIVE_REPORTS,
  CREATE_ACQUISITION,
  READ_ACQUISITION,
  READ_USER_ACQUISITION,
  READ_ORGANIZATION_ACQUISITION,
  READ_PLATFORM_ACQUISITION,
  CREATE_ACQUISITION_FEATURIZATION,
  READ_ACQUISITION_FEATURIZATION,
  UPDATE_ACQUISITION_FEATURIZATION,
  CREATE_ANALYTE,
  CREATE_ANALYTE_USE,
  READ_ANALYTE,
  READ_BASE_ANALYTE,
  PROMOTE_ANALYTE,
  UPDATE_ANALYTE,
  UPDATE_ANALYTE_METHOD,
  CREATE_ADDUCT,
  READ_ADDUCT,
  CREATE_METHOD,
  READ_METHOD,
  UPDATE_METHOD,
  CREATE_PRODUCT,
  READ_ORGANIZATION_PRODUCT,
  READ_PLATFORM_PRODUCT,
  UPDATE_PRODUCT,
  READ_CANDLES,
  READ_ANALYTE_EMBEDDING,
  CREATE_ANALYTE_EMBEDDING,
  VIEW_EXPERIMENTS_PAGE,
  VIEW_EXPERIMENTS_V2_PAGE,
  VIEW_ADMIN_PAGE,
  VIEW_INFERENCE_RESULTS_PAGE,
  VIEW_ORGANIZATIONS_PAGE,
  VIEW_ORGANIZATION_SETUP_PAGE,
  VIEW_DOWNLOAD_SOURCE_FILE,
  VIEW_METADATA_PAGE,
  VIEW_PROGRAMS_PAGE,
  VIEW_JOB_RESULTS_PAGE,
  VIEW_ANALYTE_PAGE: VIEW_ANALYTES_PAGE,
  VIEW_PRODUCTS_PAGE,
  VIEW_PEAK_AREA_PLOT,
  VIEW_XIC_PLOT,
  CREATE_PRIVILEGED_SAMPLE_METADATA,
  READ_PRIVILEGED_SAMPLE_METADATA,
  UPDATE_PRIVILEGED_SAMPLE_METADATA,
  VIEW_RESULTS_METADATA,
  READ_EMBEDDINGS_UMAP,
  READ_SAMPLE_EMBEDDINGS,
  READ_USER_AGENT_ANALYSIS,
  READ_USER_AGENT_CHAT,
  CREATE_CONFIG,
  READ_CONFIG,
  UPDATE_CONFIG,
  CREATE_MODEL,
  READ_MODEL,
  UPDATE_MODEL,
  DELETE_USER_SAMPLE_METADATA,
  DELETE_ORGANIZATION_SAMPLE_METADATA,
  DELETE_PLATFORM_SAMPLE_METADATA,
} as const;

export {
  CREATE_ACQUISITION,
  CREATE_ACQUISITION_FEATURIZATION,
  CREATE_ADDUCT,
  CREATE_ANALYTE,
  CREATE_ANALYTE_EMBEDDING,
  CREATE_ANALYTE_USE,
  CREATE_CONFIG,
  CREATE_CUSTOM_JOB,
  CREATE_INFERENCE_RESULT,
  CREATE_JOB_CONFIG,
  CREATE_METHOD,
  CREATE_MODEL,
  CREATE_ORGANIZATION,
  CREATE_ORGANIZATION_JOB,
  CREATE_ORGANIZATION_SAMPLE,
  CREATE_ORGANIZATION_USER,
  CREATE_PLATFORM_JOB,
  CREATE_PLATFORM_SAMPLE,
  CREATE_PLATFORM_SAMPLE_SET,
  CREATE_PLATFORM_USER,
  CREATE_PRIVILEGED_SAMPLE_METADATA,
  CREATE_PRODUCT,
  CREATE_QC_CHECK,
  CREATE_QC_FEATURE,
  CREATE_SAMPLE,
  CREATE_SAMPLE_SET,
  CREATE_SAMPLE_SET_METADATA,
  CREATE_TRAINING_LABEL,
  CREATE_USER_JOB,
  DELETE_ORGANIZATION_SAMPLE,
  DELETE_ORGANIZATION_SAMPLE_METADATA,
  DELETE_ORGANIZATION_SAMPLE_SET,
  DELETE_PLATFORM_SAMPLE,
  DELETE_PLATFORM_SAMPLE_METADATA,
  DELETE_PLATFORM_SAMPLE_SET,
  DELETE_USER_SAMPLE,
  DELETE_USER_SAMPLE_METADATA,
  DELETE_USER_SAMPLE_SET,
  PROMOTE_ANALYTE,
  PUBLISH_ORGANIZATION_INTERPRETIVE_REPORTS,
  PUBLISH_PLATFORM_INTERPRETIVE_REPORTS,
  PUBLISH_USER_INTERPRETIVE_REPORTS,
  READ_ACQUISITION,
  READ_ACQUISITION_FEATURIZATION,
  READ_ADDUCT,
  READ_ANALYTE,
  READ_ANALYTE_EMBEDDING,
  READ_BASE_ANALYTE,
  READ_CANDLES,
  READ_CONFIG,
  READ_EMBEDDINGS_UMAP,
  READ_INFERENCE_RESULT,
  READ_METHOD,
  READ_MODEL,
  READ_ORGANIZATION,
  READ_ORGANIZATION_ACQUISITION,
  READ_ORGANIZATION_INFERENCE_RESULT,
  READ_ORGANIZATION_INTERPRETIVE_REPORTS,
  READ_ORGANIZATION_JOBS,
  READ_ORGANIZATION_PRODUCT,
  READ_ORGANIZATION_SAMPLE_SETS,
  READ_ORGANIZATION_SAMPLES,
  READ_ORGANIZATION_USERS,
  READ_PLATFORM_ACQUISITION,
  READ_PLATFORM_INFERENCE_RESULT,
  READ_PLATFORM_INTERPRETIVE_REPORTS,
  READ_PLATFORM_JOBS,
  READ_PLATFORM_PRODUCT,
  READ_PLATFORM_SAMPLE_SETS,
  READ_PLATFORM_SAMPLES,
  READ_PLATFORM_USERS,
  READ_PRIVILEGED_SAMPLE_METADATA,
  READ_PRODUCT_VIEWER,
  READ_PROPRIETARY_REPORT_INFO,
  READ_QC_CHECK,
  READ_QC_FEATURE,
  READ_SAMPLE_EMBEDDINGS,
  READ_TRAINING_LABEL,
  READ_USER,
  READ_USER_ACQUISITION,
  READ_USER_AGENT_ANALYSIS,
  READ_USER_AGENT_CHAT,
  READ_USER_INFERENCE_RESULT,
  READ_USER_INTERPRETIVE_REPORTS,
  READ_USER_JOBS,
  READ_USER_SAMPLE_SETS,
  READ_USER_SAMPLES,
  UPDATE_ACQUISITION_FEATURIZATION,
  UPDATE_ANALYTE,
  UPDATE_ANALYTE_METHOD,
  UPDATE_CONFIG,
  UPDATE_JOB_STATUS,
  UPDATE_METHOD,
  UPDATE_MODEL,
  UPDATE_ORGANIZATION,
  UPDATE_ORGANIZATION_SAMPLE,
  UPDATE_ORGANIZATION_SAMPLE_SET,
  UPDATE_ORGANIZATION_USERS,
  UPDATE_PLATFORM_INFERENCE_RESULT_LABEL,
  UPDATE_PLATFORM_SAMPLE,
  UPDATE_PLATFORM_SAMPLE_SET,
  UPDATE_PLATFORM_USERS,
  UPDATE_PRIVILEGED_SAMPLE_METADATA,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_VIEWER,
  UPDATE_SAMPLE_STATUS,
  UPDATE_TRAINING_LABEL,
  UPDATE_USER,
  UPDATE_USER_SAMPLE,
  UPDATE_USER_SAMPLE_SET,
  VIEW_ADMIN_PAGE,
  VIEW_ANALYTES_PAGE as VIEW_ANALYTE_PAGE,
  VIEW_DOWNLOAD_SOURCE_FILE,
  VIEW_EXPERIMENTS_PAGE,
  VIEW_EXPERIMENTS_V2_PAGE,
  VIEW_INFERENCE_RESULTS_PAGE,
  VIEW_JOB_RESULTS_PAGE,
  VIEW_METADATA_PAGE,
  VIEW_ORGANIZATION_SETUP_PAGE,
  VIEW_ORGANIZATIONS_PAGE,
  VIEW_PEAK_AREA_PLOT,
  VIEW_PRODUCTS_PAGE,
  VIEW_PROGRAMS_PAGE,
  VIEW_RESULTS_METADATA,
  VIEW_XIC_PLOT,
};

export type PermissionString =
  (typeof PERMISSIONS_STRINGS)[keyof typeof PERMISSIONS_STRINGS];

export const canUploadSamples = (sampleSetStatus: SampleSetStatus): boolean => {
  return [
    null,
    SampleSetStatus.UPLOAD_SAMPLES,
    SampleSetStatus.SAMPLE_WARNING,
    SampleSetStatus.SAMPLE_ERROR,
    SampleSetStatus.UNKNOWN,
    SampleSetStatus.READY,
  ].includes(sampleSetStatus);
};

/**
 * Checks if a user can edit a sample set based on ownership and permissions.
 * A user can edit a sample set if they are:
 * - The owner of the sample set
 * - Have UPDATE_ORGANIZATION_SAMPLE_SET permission and share an org with the owner
 * - Have UPDATE_PLATFORM_SAMPLE_SET permission (platform admin)
 *
 * @param userData - Relevant subset of user data
 * @param sampleSet - Relevant subset of sample set
 * @returns true if the user can edit the sample set, false otherwise
 */
export const canEditSampleSet = (
  userData: {
    id: string;
    permissions?: string[];
    org?: { id: string } | null;
  } | null,
  sampleSet: {
    owner_id: string;
    user?: { org?: { id: string } | null };
  } | null
): boolean => {
  if (!userData || !sampleSet) {
    return false;
  }
  const { id, permissions = [], org } = userData;
  const { owner_id, user } = sampleSet;

  // Direct ownership
  if (id === owner_id) {
    return true;
  }

  // Platform admin
  if (permissions.includes(UPDATE_PLATFORM_SAMPLE_SET)) {
    return true;
  }

  // Org admin - check if user and owner are in the same org
  if (
    permissions.includes(UPDATE_ORGANIZATION_SAMPLE_SET) &&
    org &&
    user?.org
  ) {
    return org.id === user.org.id;
  }

  return false;
};

export const canShareSampleSet = (
  userData: {
    id: string;
    permissions?: string[];
    org?: { id: string } | null;
  } | null,
  sampleSet: {
    owner_id: string;
    user?: { org?: { id: string } | null };
  } | null
): boolean => {
  if (!userData || !sampleSet) {
    return false;
  }
  const { permissions = [], org } = userData;
  const { user } = sampleSet;

  // Platform admin
  if (permissions.includes(UPDATE_PLATFORM_SAMPLE_SET)) {
    return true;
  }

  // Org admin - check if user and owner are in the same org
  if (
    permissions.includes(UPDATE_ORGANIZATION_SAMPLE_SET) &&
    org &&
    user?.org
  ) {
    return org.id === user.org.id;
  }

  return false;
};
